export default __webpack_public_path__ + "static/headquarters-aa076504eb195ce2458ca75ef6956dc0.jpg";